import { useTranslation } from 'react-i18next';

import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

const OnCloseConfirmationModal = () => {
  const { t } = useTranslation('common');
  const { closeModal } = useModal();

  return (
    <ConfirmationModal
      header={t('going-somewhere-else')}
      message={t('you-will-lose-all-data')}
      variant='warning'
      dismissText={t('continue-editing')}
      confirmText={t('discard-and-exit')}
      onDismissRemoveNumber={1}
      onConfirm={closeModal}
      buttonsAlignment='col'
      preferredAction='dismiss'
    />
  );
};
export { OnCloseConfirmationModal };
